import { render, staticRenderFns } from "./ItemImages.vue?vue&type=template&id=28222110&scoped=true&"
import script from "./ItemImages.vue?vue&type=script&lang=js&"
export * from "./ItemImages.vue?vue&type=script&lang=js&"
import style0 from "./ItemImages.vue?vue&type=style&index=0&id=28222110&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28222110",
  null
  
)

export default component.exports